
// components/popup/ReporterPopup.tsx
import React, { Dispatch, SetStateAction } from 'react';
import { PersonSearchPopup } from './PersonSearchPopup';
import { Person } from 'types';

interface ReporterPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  onSearchPerson: (e: React.FormEvent) => void;
  onPersonSelect: (personId: string) => void;
  onUserSubmit: (data: any, isEditMode: boolean) => void;
  formData: any;
  loading: boolean;
  error: string | null;
  searchFayda: string;
  setSearchFayda: (value: string) => void;
  searchPhone: string;
  setSearchPhone: (value: string) => void;
  searchedPersons: any[];
  selectedPerson: any;
  selectedPersonId: string;
  searchLoading: boolean;
  userFormLoading: boolean;
  isEditMode?: boolean;
  existingData?: any;
     setSelectedPerson?: Dispatch<SetStateAction<Person | null>>;
      setSelectedPersonId?: Dispatch<SetStateAction<string>>;
      setSearchedPersons?: Dispatch<SetStateAction<Person[]>>;
}

export const ReporterPopup: React.FC<ReporterPopupProps> = (props) => {
  return (
    <PersonSearchPopup
      {...props}
      title={props.isEditMode ? "Edit Reporter" : "Add Reporter"}
      description={props.isEditMode ? "Edit reporter information" : "Add reporter information"}
      isEditMode={props.isEditMode}
      existingData={props.existingData}
        setSearchedPersons={props.setSearchedPersons}
      setSelectedPerson={props.setSelectedPerson}
      setSelectedPersonId={props.setSelectedPersonId}
    >
      <div className="flex flex-col">
        <label className="referral-popup-label">Relationship to Case</label>
        <input
          type="text"
          className="referral-form-field"
          onChange={props.onInputChange}
          name="relationship_to_case"
          placeholder="Relationship to Case"
          value={props.formData.relationship_to_case}
        />
      </div>
    </PersonSearchPopup>
  );
};